/**
 * Multi-step cut selection form wizard
 * Handles step navigation, validation, and review summary
 */
document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('cut-form');
    if (!form) return;

    const steps = form.querySelectorAll('.form-step');
    const dots  = form.querySelectorAll('.step-dot');
    const btnPrev   = document.getElementById('btn-prev');
    const btnNext   = document.getElementById('btn-next');
    const btnSubmit = document.getElementById('btn-submit');

    let currentStep = 1;
    const totalSteps = steps.length;

    function showStep(step) {
        currentStep = step;

        // Toggle step visibility
        steps.forEach(s => {
            s.classList.toggle('active', parseInt(s.dataset.step) === step);
        });

        // Update step dots
        dots.forEach(d => {
            const dotStep = parseInt(d.dataset.step);
            d.classList.remove('active', 'completed');
            if (dotStep === step) d.classList.add('active');
            if (dotStep < step) d.classList.add('completed');
        });

        // Toggle buttons
        btnPrev.classList.toggle('hidden', step === 1);
        btnNext.classList.toggle('hidden', step === totalSteps);
        btnSubmit.classList.toggle('hidden', step !== totalSteps);

        // Build review summary on last step
        if (step === totalSteps) {
            buildReview();
        }

        // Scroll to top of form
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function validateStep(step) {
        const stepEl = form.querySelector(`.form-step[data-step="${step}"]`);

        if (step === 1) {
            // Validate required fields
            const required = stepEl.querySelectorAll('[required]');
            let valid = true;
            required.forEach(input => {
                if (!input.value.trim()) {
                    input.style.borderColor = '#914014';
                    valid = false;
                } else {
                    input.style.borderColor = '';
                }
            });
            return valid;
        }

        if (step === 2) {
            // Validate all cut radio groups have a selection
            const cutRows = stepEl.querySelectorAll('.cut-row');
            if (cutRows.length === 0) return true;
            const radioGroups = new Set();
            cutRows.forEach(row => {
                row.querySelectorAll('input[type="radio"]').forEach(r => radioGroups.add(r.name));
            });
            for (const group of radioGroups) {
                if (!stepEl.querySelector(`input[name="${group}"]:checked`)) {
                    alert('Please select an option for every cut before proceeding.');
                    return false;
                }
            }
            return true;
        }

        if (step === 3) {
            // Validate extras — bones, pack-for, and packaging
            const radioGroups = new Set();
            stepEl.querySelectorAll('input[type="radio"]').forEach(r => radioGroups.add(r.name));
            for (const group of radioGroups) {
                if (!stepEl.querySelector(`input[name="${group}"]:checked`)) {
                    alert('Please complete all selections before proceeding.');
                    return false;
                }
            }
            return true;
        }

        return true;
    }

    function buildReview() {
        const summary = document.getElementById('review-summary');
        if (!summary) return;

        summary.innerHTML = '';
        const formData = new FormData(form);
        let hasEntries = false;

        for (const [key, value] of formData.entries()) {
            if (key === 'id' || key === 'quantity' || !value) continue;

            hasEntries = true;
            const match = key.match(/properties\[(.+)\]/);
            const label = match ? match[1] : key;

            const row = document.createElement('div');
            row.className = 'review-item';
            const labelSpan = document.createElement('span');
            labelSpan.className = 'review-label';
            labelSpan.textContent = label;
            const valueSpan = document.createElement('span');
            valueSpan.className = 'review-value';
            valueSpan.textContent = value;
            row.append(labelSpan, valueSpan);
            summary.appendChild(row);
        }

        if (!hasEntries) {
            const p = document.createElement('p');
            p.className = 'text-brand-brown/40';
            p.textContent = 'No selections made yet.';
            summary.appendChild(p);
        }
    }

    // Event listeners
    btnNext.addEventListener('click', () => {
        if (validateStep(currentStep) && currentStep < totalSteps) {
            showStep(currentStep + 1);
        }
    });

    btnPrev.addEventListener('click', () => {
        if (currentStep > 1) {
            showStep(currentStep - 1);
        }
    });

    // Allow clicking step dots to navigate
    dots.forEach(dot => {
        dot.addEventListener('click', () => {
            const targetStep = parseInt(dot.dataset.step);
            if (targetStep < currentStep) {
                showStep(targetStep);
            }
        });
        dot.style.cursor = 'pointer';
    });

    // Init
    showStep(1);
});
